// Function to construct the Visa URL in the backend
import environment from "../env";

export const constructVisaTinkUrl = (
  authorizationCode: string,
  state: string = ""
) => {
  const visaUrl = environment.visaUrl; // Replace with the actual Visa URL
  const clientId = environment.clientId;
  const redirectUri = environment.callbackUrl;
  const visaParams = {
    client_id: clientId,
    authorization_code: authorizationCode,
    state,
    redirect_uri: redirectUri,
    market: "US",
    locale: "en_US",
  };

  // Construct the full Visa URL
  const fullVisaUrl = new URL(visaUrl);
  fullVisaUrl.search = new URLSearchParams(visaParams).toString();

  return fullVisaUrl.href;
};
